import React from 'react';
import PropTypes from 'prop-types';
import style from './error.module.less';
import AppLink from '../links/AppLink';

export default function Error({ heading, description, err }) {
  const isPageNotFoundError = err && err.statusCode && err.statusCode === 404;

  const headingData = heading ? (
    heading
  ) : isPageNotFoundError ? (
    <>The page you&apos;re looking for doesn&apos;t exist.</>
  ) : (
    'We need a moment'
  );
  const descriptionData = description ? (
    description
  ) : (
    <>Our servers experienced an unexpected error</>
  );

  if (err && typeof window !== 'undefined') {
    window.newrelic &&
      window.newrelic.noticeError &&
      window.newrelic.noticeError(err);
  }

  return (
    <article className={style.container}>
      <div className={style['logo-container']}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 4729 994"
          className={style.logo}
        >
          <path d="m 613,994 h 351 a 31,31 0 0 0 22,-10 32,32 0 0 0 10,-22 l -1,-347 a 31,31 0 0 0 -9,-26 l -447,-448 a 93,93 0 0 0 -67,-27 93,93 0 0 0 -66,27 c -36,37 -36,96 0,133 l 315,314 a 30,30 0 0 1 9,22 30,30 0 0 1 -9,21 30,30 0 0 1 -22,9 30,30 0 0 1 -21,-9 l -315,-314 a 93,93 0 0 0 -66,-28 93,93 0 0 0 -66,28 c -37,36 -37,96 0,132 l 314,315 a 31,31 0 0 1 0,43 30,30 0 0 1 -21,9 30,30 0 0 1 -22,-9 L 76,381 405,52 a 32,32 0 0 0 0,-44 c -6,-6 -12,-8 -20,-8 -9,0 -18,2 -24,8 L 9,359 a 32,32 0 0 0 0,45 L 457,852 a 93,93 0 0 0 67,27 c 25,0 48,-10 66,-27 36,-37 36,-96 0,-133 l -315,-315 a 30,30 0 0 1 -9,-21 30,30 0 0 1 9,-22 30,30 0 0 1 22,-8 c 8,0 16,3 21,8 l 315,315 a 93,93 0 0 0 66,27 c 25,0 49,-9 66,-27 a 93,93 0 0 0 28,-66 93,93 0 0 0 -28,-67 l -314,-314 a 31,31 0 0 1 0,-43 30,30 0 0 1 21,-9 c 9,0 16,3 22,9 l 438,438 v 306 l -319,1 a 31,31 0 0 0 -23,9 31,31 0 0 0 -9,23 32,32 0 0 0 32,31 z m 4058,0 h 58 V 833 c 0,-80 -40,-121 -104,-121 -63,0 -95,46 -95,46 0,0 -23,-46 -83,-46 -46,0 -75,35 -75,35 v -29 h -57 v 276 h 57 V 845 c 0,-52 29,-81 63,-81 35,0 58,23 58,69 v 161 h 57 V 845 c 0,-52 29,-81 64,-81 34,0 57,23 57,69 z m -538,-287 c -77,0 -143,66 -143,144 0,78 66,143 143,143 77,0 144,-66 144,-143 0,-78 -66,-144 -144,-144 z m 0,51 c 46,0 87,41 87,93 0,51 -41,92 -87,92 -46,0 -86,-41 -86,-92 0,-52 40,-93 86,-93 z m -273,-51 c -77,0 -144,66 -144,144 0,78 67,143 144,143 72,0 115,-57 115,-57 l -37,-38 c 0,0 -29,44 -78,44 -46,0 -86,-41 -86,-92 0,-52 40,-93 86,-93 49,0 75,41 75,41 l 37,-38 c 0,0 -40,-54 -112,-54 z m -204,287 c 20,0 37,-17 37,-37 0,-20 -17,-37 -37,-37 -20,0 -37,17 -37,37 0,20 17,37 37,37 z m -279,-276 h -58 v 276 h 58 V 845 c 0,-52 29,-81 72,-81 37,0 66,29 66,69 v 161 h 58 V 833 c 0,-75 -46,-121 -113,-121 -51,0 -83,35 -83,35 z m -239,-11 c -77,0 -144,66 -144,144 0,78 67,143 144,143 78,0 144,-66 144,-143 0,-78 -66,-144 -144,-144 z m 0,51 c 46,0 87,41 87,93 0,51 -41,92 -87,92 -46,0 -86,-41 -86,-92 0,-52 40,-93 86,-93 z m -213,-92 c 21,0 35,-14 35,-34 0,-20 -14,-35 -35,-35 -20,0 -34,15 -34,35 0,20 14,34 34,34 z m -28,328 h 57 V 718 h -57 z m -161,-316 c 0,23 -12,34 -29,34 h -29 v 52 h 52 v 144 c 0,58 29,86 80,86 23,0 41,-5 41,-5 v -52 c 0,0 -15,6 -29,6 -20,0 -35,-15 -35,-36 V 764 h 58 v -52 h -58 v -92 h -51 z m -90,311 V 810 c 0,-57 -46,-103 -115,-103 -72,0 -109,51 -109,51 l 37,38 c 0,0 23,-38 72,-38 35,0 58,23 58,52 l -101,17 c -49,9 -80,41 -80,87 0,40 40,80 97,80 52,0 84,-34 84,-34 v 29 z m -57,-127 c 0,52 -29,81 -75,81 -32,0 -49,-18 -49,-35 0,-20 15,-34 35,-37 l 89,-15 z m -311,-155 c -77,0 -144,66 -144,144 0,78 67,143 144,143 72,0 115,-57 115,-57 l -37,-38 c 0,0 -29,44 -78,44 -46,0 -86,-41 -86,-92 0,-52 40,-93 86,-93 49,0 75,41 75,41 l 37,-38 c 0,0 -40,-54 -112,-54 z m -241,282 h 57 V 712 h -57 v 150 c 0,52 -29,81 -72,81 -38,0 -66,-29 -66,-69 V 712 h -58 v 162 c 0,74 46,120 112,120 52,0 84,-34 84,-34 z m -314,-245 c 0,0 -34,-37 -89,-37 -72,0 -135,63 -135,144 0,80 63,143 135,143 55,0 89,-37 89,-37 v 32 h 58 V 586 h -58 z m 0,107 c 0,51 -40,92 -83,92 -43,0 -84,-41 -84,-92 0,-52 41,-93 84,-93 43,0 83,41 83,93 z m -247,86 v 57 h -291 V 592 h 285 v 57 h -221 v 107 h 175 v 57 h -175 v 124 z" />
        </svg>
      </div>
      <h1 className={style.heading}>{headingData}</h1>
      {!isPageNotFoundError ? (
        <div>
          <h3>{descriptionData}</h3>
          <p>
            If you continue to see this page, please contact us at
            <a href="mailto:support@education.com">
              &nbsp;support@education.com
            </a>
            .
          </p>
          <br />
          <p>&mdash; The Education.com Team</p>
        </div>
      ) : (
        <div>
          <h3 className="action">
            Explore the rest of our{' '}
            <AppLink href="/resources/">Learning Library</AppLink>
          </h3>
          <br />
        </div>
      )}
    </article>
  );
}

export function getPageNotFoundTitle() {
  return '404 Not Found - Education.com';
}

Error.propTypes = {
  heading: PropTypes.string.isRequired,
  description: PropTypes.any.isRequired,
  err: PropTypes.any,
};
